import { useEffect, useState, useRef, useMemo } from 'react';
import styles from './FJClothesChangerLeft.module.less';
import FJLocalStore from '../../../store/FJLocalStore';
import PropTypes from 'prop-types';
import FJGenerateButton from '../../../common/components/FJGenerateButton/FJGenerateButton';
import FJClothesChangerImageUpload from '../FJClothesChangerImageUpload/FJClothesChangerImageUpload.jsx';
import PeopleIcon from '../../../assets/svg/people-40px.svg?react';
import ClothesIcon from '../../../assets/svg/clothes-40px.svg?react';
import ClothesSmallIcon from '../../../assets/svg/clothes-24px.svg?react';
import PeopleSmallIcon from '../../../assets/svg/people-24px.svg?react';
import ExclamationIcon from '../../../assets/svg/exclamation-point.svg?react';
import classNames from 'classnames';
import FJAppLeft from '../../FJMainPreview/FJAppLeft/FJAppLeft';
import FJTipsContent from './FJTipsContent.jsx';
import useDefaultFreeLimit from '../../../hooks/useDefaultFreeLimit.jsx';
import FJClothesChangerStyleListV2Container from '../FJClothesChangerStyleList/FJClothesChangerStyleListV2Container.jsx';
import FJMenuTab from '../../../common/components/FJMenuTab/FJMenuTab.jsx';
import FJDropdownNew from '../../../common/components/FJDropDown/FJDropdownNew';
import { CLOTHES_CHANGER_MODEL_LIST } from '../../../config/dataConfig/FJClothesChangerData.js';
import FJCheckIcon from '../../../assets/svg/right.svg?react';

const FJClothesChangerLeft = props => {
    const {
        onGenerate,
        taskStatus,
        freeNumCreation,
        creditNumber,
        peopleImageInfo,
        clothesImageInfo,
        onUploadImage,
        openMediaLibrary,
        isProjectLoading,
        tab,
        onTabChange,
        onModelChange,
        selectedModel,
        onClearImage,
    } = props;
    const defaultFreeNumCreation = useDefaultFreeLimit();
    const tipsRef = useRef();
    const tipsPanel = useRef();
    const [isShowTips, setIsShowTips] = useState(false);

    const _onClickTips = () => {
        setIsShowTips(prev => !prev);
    };

    useEffect(() => {
        const __mouseDown = e => {
            if (
                (tipsPanel.current && tipsPanel.current.contains(e.target)) ||
                (tipsRef.current && tipsRef.current.contains(e.target))
            ) {
                return;
            }
            setIsShowTips(false);
        };

        if (isShowTips) {
            window.addEventListener('mousedown', __mouseDown);
        } else {
            window.removeEventListener('mousedown', __mouseDown);
        }
    }, [isShowTips]);

    const curModel = useMemo(() => {
        return CLOTHES_CHANGER_MODEL_LIST.find(item => item.value === selectedModel);
    }, [selectedModel]);

    const isFree = useMemo(() => {
        // doubao Max 无免费次数
        if (curModel?.value === 'doubao') {
            return false;
        }
        return freeNumCreation > 0 && creditNumber < curModel?.price;
    }, [freeNumCreation, creditNumber, curModel]);

    return (
        <FJAppLeft>
            <div className={classNames(styles.header)}>
                <div className={classNames(styles.title)}>{FJLocalStore._('upload-image')}</div>
                <div className={styles.tips} onClick={_onClickTips} ref={tipsRef}>
                    {FJLocalStore._('tips')}
                    <ExclamationIcon />
                </div>
            </div>

            <div className={styles.upload_box}>
                <FJClothesChangerImageUpload
                    openMediaLibrary={() => openMediaLibrary('people')}
                    imageInfo={peopleImageInfo}
                    uploadImg={file => {
                        onUploadImage(file);
                    }}
                    defaultIcon={() => <PeopleIcon />}
                    smallIcon={() => <PeopleSmallIcon />}
                    uploadText={'upload-photo'}
                    onClearImage={() => onClearImage(false)}
                    smallLabel={'clothes-upload-model'}
                />
                <FJClothesChangerImageUpload
                    openMediaLibrary={() => openMediaLibrary('clothes')}
                    imageInfo={clothesImageInfo}
                    uploadImg={file => {
                        onUploadImage(file, true);
                    }}
                    defaultIcon={() => <ClothesIcon />}
                    smallIcon={() => <ClothesSmallIcon />}
                    uploadText={'upload-clothes'}
                    onClearImage={() => onClearImage(true)}
                    smallLabel={'clothes'}
                    previewClassName={styles.clothes_preview_box}
                />
            </div>
            <div className={classNames(styles.title)} style={{ marginBottom: 10 }}>
                {FJLocalStore._('clothes')}
            </div>
            <FJMenuTab
                className={styles.tab_box}
                list={[{ text: 'women' }, { text: 'men' }]}
                curIndex={tab}
                onChange={onTabChange}
            />
            <FJClothesChangerStyleListV2Container />
            <div className={styles.line_through} />

            <div className={styles.bottom_box}>
                <FJDropdownNew
                    canTriggerActive
                    renderTrigger={config => (
                        <div
                            className={styles.model_selector}
                            ref={config.ref}
                            onClick={config.onClick}
                            data-active={config.active}
                        >
                            {curModel?.icon && <curModel.icon className={styles.model_selector_icon} />}
                            <div className={styles.model_selector_content}>
                                <span className={styles.model_selector_value}>{FJLocalStore._(curModel?.name)}</span>
                            </div>
                        </div>
                    )}
                    renderOverlay={config => (
                        <div className={styles.model_dropdown} ref={config.ref}>
                            <span className={styles.model_selector_title}>{FJLocalStore._('model')}</span>
                            {CLOTHES_CHANGER_MODEL_LIST.map((model, index) => (
                                <div
                                    key={index}
                                    className={`${styles.model_option} ${selectedModel === model.value ? styles.selected : ''}`}
                                    onClick={() => {
                                        onModelChange(model.value);
                                        config.hide();
                                    }}
                                >
                                    <model.icon className={styles.model_option_icon} />
                                    <div className={styles.model_option_name}>{FJLocalStore._(model.name)}</div>
                                    <div className={styles.model_option_description}>
                                        {FJLocalStore._(model.description)}
                                    </div>
                                    <FJCheckIcon className={styles.model_option_check_icon} />
                                </div>
                            ))}
                        </div>
                    )}
                    placement='topLeft'
                    offsetTop={-36}
                    offsetLeft={-22}
                    useAnchorBody
                    isTopLayer
                />
                <div className={styles.generate_button_box}>
                    <FJGenerateButton
                        onClick={onGenerate}
                        taskStatus={taskStatus}
                        freeNumCreation={freeNumCreation}
                        isFree={isFree}
                        useCredit={curModel.price}
                        isProjectLoading={isProjectLoading}
                        defaultFreeNumCreation={selectedModel === 'doubao' ? 0 : defaultFreeNumCreation}
                    />
                </div>
            </div>

            <div ref={tipsPanel} className={classNames(styles.tips_content, { [styles.show]: isShowTips })}>
                <FJTipsContent />
            </div>
        </FJAppLeft>
    );
};
FJClothesChangerLeft.propTypes = {
    onGenerate: PropTypes.func,
    taskStatus: PropTypes.string,
    freeNumCreation: PropTypes.number,
    creditNumber: PropTypes.number,
    peopleImageInfo: PropTypes.object,
    clothesImageInfo: PropTypes.object,
    onUploadImage: PropTypes.func,
    selectedStyle: PropTypes.string,
    onSelectClothes: PropTypes.func,
    isProjectLoading: PropTypes.bool,
    openMediaLibrary: PropTypes.func,
    selectedName: PropTypes.string,
    tab: PropTypes.number,
    onTabChange: PropTypes.func,
    onModelChange: PropTypes.func,
    selectedModel: PropTypes.string,
    onClearImage: PropTypes.func,
};
export default FJClothesChangerLeft;
